import {Collapse} from 'antd';
import cn from 'classnames';
import React, {FC, ReactNode} from 'react';

import {DESIGN_TEMPLATES_WITH_PARAMETERS} from 'components/table-report/table-report-types';
import {ReactComponent as AccordionIcon} from 'shared/assets/accordion-icon.svg';
import {useAppSelector} from 'store/config/hooks';
import {
    selectTableReportHeaders,
    selectTableReportTemplateConfig,
} from 'store/slices/table-report-slice/table-report-slice-selectors';

import './collapsible-header.less';

interface ICollapsibleHeaderProps {
    reportName?: string;
    designTemplate?: string;
    children?: ReactNode;
}

export const CollapsibleHeader: FC<ICollapsibleHeaderProps> = (
    {children, reportName, designTemplate}: ICollapsibleHeaderProps,
) => {
    const headers = useAppSelector(selectTableReportHeaders);
    const {queryParameters} = useAppSelector(selectTableReportTemplateConfig) || {};
    const hasVisibleParameters: boolean = !!queryParameters && queryParameters.some(param => param.visible);
    const hasHeaders = !!(headers.caption || headers.others?.length);

    const isCollapsible = (
        (DESIGN_TEMPLATES_WITH_PARAMETERS?.includes(designTemplate ?? '') && hasVisibleParameters)
        || (!DESIGN_TEMPLATES_WITH_PARAMETERS?.includes(designTemplate ?? '') && hasHeaders)
    );

    return (
        <Collapse
            className={cn('collapsible-header', {collapsible: isCollapsible})}
            ghost
            defaultActiveKey={isCollapsible ? ['1'] : undefined}
            expandIcon={() => <AccordionIcon />}
        >
            <Collapse.Panel
                key="1"
                header={reportName}
                disabled={!isCollapsible}
                showArrow={isCollapsible}
            >
                {children}
            </Collapse.Panel>
        </Collapse>
    );
};
